import cx from 'classnames'

import styles from './BlankScreen.module.css'

type Props = {
  type: 'experiment' | 'project'
}

const titles = {
  experiment: 'No experiment selected',
  project: 'No project selected',
}

const texts = {
  experiment: 'Select an experiment to view all the nitty, gritty details.',
  project: 'Select a project to view all the nitty, gritty details.',
}

const BlankScreen: React.FC<Props> = ({ type }) => {
  return (
    <div className="h-full bg-white text-coolGray-800">
      <div>
        <img className={styles.image} src="/images/astronaut-rgb.svg" alt="" />
        <div
          className={cx(
            'text-4xl font-bold text-coolGray-800 transform -rotate-6',
            styles.imageText
          )}
        >
          Spaceman, I always wanted you to go into spaceman…
        </div>
      </div>

      <div className="flex flex-col items-center justify-center">
        <div className="w-106 py-12">
          <div className="text-4xl font-bold">{titles[type]}</div>
          <div className="mt-6 text-base">{texts[type]}</div>
        </div>
      </div>
    </div>
  )
}

export default BlankScreen
